import { useTranslation } from 'react-i18next';
import { getLandingContent } from '@/mocks/landingData';

export default function EquipmentSection() {
  const { i18n } = useTranslation();
  const { equipment } = getLandingContent(i18n.language);

  return (
    <section id="equipment" className="py-20 md:py-28 bg-gray-900">
      <div className="px-6 md:px-10 lg:px-16">
        <p className="text-red-500 text-sm font-medium tracking-widest uppercase mb-4 md:mb-6">
          {equipment.eyebrow}
        </p>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6 max-w-4xl leading-tight">
          {equipment.title}
        </h2>
        <p className="text-base md:text-lg text-gray-400 max-w-2xl mb-14 md:mb-20 leading-relaxed">
          {equipment.subtitle}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 md:gap-6">
          {equipment.items.map((item) => (
            <div
              key={item.id}
              className="group rounded-lg overflow-hidden bg-gray-800 border border-gray-700 flex flex-col"
              data-product-shop
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-white">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-contain p-5 transition-transform duration-500 group-hover:scale-105"
                  width={600}
                  height={450}
                />
              </div>
              <div className="p-6 md:p-7 flex-1 flex flex-col">
                <h3 className="text-lg md:text-xl font-semibold text-white mb-3 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed mb-5 flex-1">
                  {item.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {item.features.map((feature) => (
                    <span
                      key={feature}
                      className="inline-flex items-center gap-1.5 text-xs text-red-400 bg-red-900/30 px-3 py-1.5 rounded-full"
                    >
                      <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
